import { useState } from 'react';
import { categories, mainSiteUrl } from '@/mocks/categories';

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-background-50/80 backdrop-blur-md border-b border-background-200/60">
      <nav className="max-w-7xl mx-auto px-4 md:px-6 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 flex-shrink-0">
          <span className="font-heading text-lg md:text-2xl font-semibold text-foreground-900 tracking-tight">
            Kakobuy <span className="text-primary-600">Spreadsheet</span> Hub
          </span>
        </Link>

        {/* Desktop nav */}
        <div className="hidden md:flex items-center gap-6">
          <Link to="/" className="text-sm font-medium text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap cursor-pointer">
            Home
          </Link>
          <Link to="/kakobuy-spreadsheet-guide" className="text-sm font-medium text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap cursor-pointer">
            Shopping Guide
          </Link>
          <a href="/#categories" className="text-sm font-medium text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap cursor-pointer">
            Categories
          </a>
          <a href="/#articles" className="text-sm font-medium text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap cursor-pointer">
            Articles
          </a>
          <a href="/#faq" className="text-sm font-medium text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap cursor-pointer">
            FAQ
          </a>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="bg-primary-500 hover:bg-primary-600 text-background-50 px-5 py-2.5 rounded-full text-sm font-semibold transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Open Spreadsheet
          </a>
        </div>

        {/* Mobile hamburger */}
        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 cursor-pointer"
          aria-label="Toggle menu"
        >
          <i className={`text-2xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </nav>

      {/* Mobile menu panel */}
      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/60 animate-in slide-in-from-top-2 duration-200">
          <div className="px-4 py-4 space-y-1">
            <Link
              to="/"
              onClick={() => setMobileOpen(false)}
              className="flex items-center gap-3 px-3 py-3 rounded-xl text-sm font-medium text-foreground-700 hover:bg-accent-50 hover:text-accent-800 transition-colors cursor-pointer"
            >
              <div className="w-8 h-8 flex items-center justify-center bg-accent-100/60 text-accent-600 rounded-lg">
                <i className="ri-home-line"></i>
              </div>
              Home
            </Link>
            <Link
              to="/kakobuy-spreadsheet-guide"
              onClick={() => setMobileOpen(false)}
              className="flex items-center gap-3 px-3 py-3 rounded-xl text-sm font-medium text-foreground-700 hover:bg-accent-50 hover:text-accent-800 transition-colors cursor-pointer"
            >
              <div className="w-8 h-8 flex items-center justify-center bg-accent-100/60 text-accent-600 rounded-lg">
                <i className="ri-book-open-line"></i>
              </div>
              Shopping Guide
            </Link>
          </div>

          <div className="px-4 py-2">
            <p className="text-xs font-semibold text-foreground-400 uppercase tracking-wider px-3 mb-2">Categories</p>
            <div className="space-y-1 max-h-60 overflow-y-auto">
              {categories.map((cat) => (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  onClick={() => setMobileOpen(false)}
                  className="flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm text-foreground-600 hover:bg-accent-50 hover:text-accent-800 transition-colors cursor-pointer"
                >
                  <div className="w-8 h-8 flex items-center justify-center bg-accent-100/60 text-accent-600 rounded-lg flex-shrink-0">
                    <i className={`${cat.icon} text-sm`}></i>
                  </div>
                  <span className="truncate">{cat.name}</span>
                  <div className="ml-auto w-3.5 h-3.5 flex items-center justify-center text-foreground-300 flex-shrink-0">
                    <i className="ri-external-link-line text-xs"></i>
                  </div>
                </a>
              ))}
            </div>
          </div>

          <div className="px-4 py-4 border-t border-background-200/60">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              onClick={() => setMobileOpen(false)}
              className="flex items-center justify-center gap-2 w-full bg-primary-500 hover:bg-primary-600 text-background-50 py-3 rounded-xl text-sm font-semibold transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              Open Spreadsheet
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-up-line text-sm"></i>
              </div>
            </a>
          </div>
        </div>
      )}
    </header>
  );
}